module.exports = __webpack_public_path__ + "media/packs/images/flags/VN-7d1abf8f28832406b216f5cab684c3c2.png";